module.exports = __webpack_public_path__ + "img/bologna_trafficlight_background_hero.dac30176.png";